
import { useEffect } from "react";
import { useEpisodeData } from "./hooks/useEpisodeData";
import { useEpisodeOperations } from "./hooks/useEpisodeOperations";
import { EpisodeInsert } from "./types";

export const useEpisodes = () => {
  const {
    episodes,
    categories,
    loading,
    fetchCategories,
    fetchEpisodes,
  } = useEpisodeData();

  const {
    saving,
    saveEpisode: saveEpisodeOperation,
    deleteEpisode: deleteEpisodeOperation,
  } = useEpisodeOperations();

  const saveEpisode = async (episode: EpisodeInsert, editingEpisodeId?: string) => {
    await saveEpisodeOperation(episode, editingEpisodeId);
    // Refresh episodes list after save
    console.log("Refreshing episodes list...");
    await fetchEpisodes();
    console.log("Episodes list refreshed");
  };

  const deleteEpisode = async (episodeId: string) => {
    await deleteEpisodeOperation(episodeId);
    // Refresh episodes list after delete
    await fetchEpisodes();
  };

  useEffect(() => {
    const loadData = async () => {
      await Promise.all([fetchCategories(), fetchEpisodes()]);
    };
    
    loadData();
  }, []);

  return {
    episodes,
    categories,
    loading,
    saving,
    saveEpisode,
    deleteEpisode,
    refetch: fetchEpisodes,
  };
};
